import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { ConnectionService } from '../connection/connection.service';
import { HelperService } from '../helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  public $ready = new BehaviorSubject<boolean>(false);
  private localeIdMap = new Map<string, string>([['de', 'de-CH'], ['fr', 'fr-CH'], ['it', 'it-CH'], ['en', 'en-GB']]);
  private currentLanguage = window['masterLanguage'] || 'de';
  private currentLocale: string;
  private translatedData: any;
  private translatedDataCache: any = {};

  constructor(private connection: ConnectionService) {
    this.currentLocale = 'de-CH';
  }

  public async loadTranslation(lang: string): Promise<boolean> {
    this.$ready.next(false);
    this.currentLocale = this.localeIdMap.get(lang) as any;
    this.currentLanguage = lang;
    import('/node_modules/@angular/common/locales/' + this.currentLocale + '.mjs').then(language => registerLocaleData(language.default));
    if ((window?.['forceAvailableLanguages']?.split(',') || ["de"]).filter(l => l !== lang)?.length) {
      this.fillLanguageCache(window['forceAvailableLanguages'].split(',')|| ['de'], lang);
    }
    const [liveResult, localResult] = await HelperService.allSettled([
      this.connection.find('ibextouch/lang/' + lang, null, 1000), this.connection.getSimple('assets/i18n/' + lang + '.json', 1000)
    ]);
    const live = liveResult.status === 'fulfilled' ? liveResult.value : (console.warn('could not get live language file'), null);
    const local = localResult.status === 'fulfilled' ? localResult.value : (console.warn('could not get local language file'), null);
    if (!live && !local && this.translatedDataCache[lang]) {
      this.translatedData = this.translatedDataCache[lang];
      this.$ready.next(true);
      return true;
    }
    this.translatedData = this.mergeObjects(live || {}, local || {});
    this.$ready.next(true);
    return true;
  }

  private async fillLanguageCache(languages, lang) {
    for (let l of languages) {
      if (!this.translatedDataCache[l]) {
        const [liveResult, localResult] = await HelperService.allSettled([
          this.connection.find('ibextouch/lang/' + l), this.connection.getSimple('assets/i18n/' + l + '.json')
        ]);
        const live = liveResult.status === 'fulfilled' ? liveResult.value : (console.warn('could not get live language file'), {});
        const local = localResult.status === 'fulfilled' ? localResult.value : (console.warn('could not get local language file'), {});
        this.translatedDataCache[l] = this.mergeObjects(live, local);
      }
    }
  }

  public get(key: string): string {
    if (_.get(this.translatedData, key)) {
      return _.get(this.translatedData, key);
    }
    return key;
  }

  public getCurrentLocale(): string {
    return this.currentLocale;
  }

  public getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  private mergeObjects(obj1, obj2) {
    const result = { ...obj1 };

    for (const key in obj2) {
      if (obj2.hasOwnProperty(key)) {
        if (result.hasOwnProperty(key) && typeof result[key] === 'object' && typeof obj2[key] === 'object') {
          result[key] = this.mergeObjects(result[key], obj2[key]);
        } else {
          result[key] = obj2[key];
        }
      }
    }

    return result;
  }
}
